import { CompanyLocationJob } from "../data/companyLocation";

export function jobLinkUniversalUrl(job: number | CompanyLocationJob) {
  const jobId = Number.isInteger(job) ? job : (job as CompanyLocationJob).id;
  return `${import.meta.env.VITE_API_SERVER_ROOT_URL}/ul/jobs/${jobId}`;
}